import { render } from "./PackageInfo.vue?vue&type=template&id=eef27bd8&scoped=true"
import script from "./PackageInfo.vue?vue&type=script&lang=js"
export * from "./PackageInfo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-eef27bd8"

export default script